import { ArticleParagraph1 } from '@cian/ui-kit';
import { ArrowDownS16 } from '@cian/ui-kit/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './MortgageOffersExpandToggle.css';
import { pluralize } from '../../../../utils/pluralize';

export interface IMortgageOffersExpandToggleProps {
  expanded: boolean;
  count: number;
  onClick: () => void;
}

export const MortgageOffersExpandToggle: React.FC<IMortgageOffersExpandToggleProps> = ({
  count,
  expanded,
  onClick,
}) => {
  const offersText = pluralize(count, ['предложение', 'предложения', 'предложений']);
  const buttonText = expanded ? `Скрыть ${offersText}` : `Показать ещё ${offersText}`;

  return (
    <div className={styles['container']} onClick={onClick} role="button" data-testid="MortgageOffersExpandToggle">
      <ArticleParagraph1 color="primary_100">{buttonText}</ArticleParagraph1>
      <span className={classNames(styles['arrow'], expanded && styles['arrow__expanded'])}>
        <ArrowDownS16 color="primary_100" />
      </span>
    </div>
  );
};
